import {action} from 'mobx';

import {EXPIRES_IN, EXPIRES_PENDING, EXPIRE_TIME} from '../../../constants/storeConstants';
import {STATE_FULFILLED, STATE_PENDING, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiBaseStore from '../common/apiBaseStore';

/**
 * ApiGenerateImageStore
 */
class ApiGenerateImageStore extends ApiBaseStore {
  /**
   * Generate image
   *
   * @param {{}} data
   */
  @action makeRequest(data) {
    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.generateImage(data)
      .then(action('generateImageSuccess', (res) => {
        this.state = STATE_FULFILLED;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;
        this.data = res;
        this.error = null;
      })).catch(action('generateImageError', (generateImageError) => {
        this.state = STATE_REJECTED;
        this[EXPIRE_TIME] = null;
        this.data = null;
        this.error = generateImageError;
      }));
  }
}

export default new ApiGenerateImageStore();
